import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { appConfig } from 'app/core/config/app.config';
import { Observable, catchError, map, of } from 'rxjs';

@Pipe({
  name: 'secure',
})
export class SecurePipe implements PipeTransform {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  transform(url): Observable<SafeUrl> {
    const { secureApiStorage } = appConfig;
    if (!secureApiStorage) return of(url);
    const token = localStorage.getItem('accessToken');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.http.get(url, { headers, responseType: 'blob' }).pipe(
      map((imageBlob: Blob) => {
        const fileUrl = URL.createObjectURL(imageBlob);
        return this.sanitizer.bypassSecurityTrustUrl(fileUrl);
      }),
      catchError((error) => {
        return of(url);
      })
    );
  }
}
